import { axios, setToken } from '../../utils/axios';

const virtualStocksAPI = {
  uploadVirtualStocks(file: FormData) {
    setToken();
    return axios.post('admin/v1/marketplaces/virtual-stocks/', file);
  },
  downloadVirtualStocks() {
    setToken();
    return axios.get('admin/v1/marketplaces/virtual-stocks/', { responseType: 'blob' });
  },
};

export { virtualStocksAPI };
